import React, { useState, useEffect } from 'react';
import { verifyEmail } from '../../services/auth';
import LottieAnimation from './LottieAnimation';
import ProxyImage from '../ProxyImage';
import './Auth.css';

const VerifyEmail: React.FC = () => {
  const [status, setStatus] = useState<'checking' | 'success' | 'error'>('checking');
  const [message, setMessage] = useState<string>('Verificando email...');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Token de verificación no válido');
      return;
    }

    const verify = async () => {
      try {
        const result = await verifyEmail(token);
        if (result.success) {
          setStatus('success');
          setMessage('Email verificado exitosamente. Ya puedes iniciar sesión.');
        } else {
          setStatus('error');
          setMessage(result.error || 'Error al verificar el email');
        }
      } catch (error) {
        setStatus('error');
        setMessage('Error de conexión. Por favor, intenta nuevamente.');
      }
    };

    verify();
  }, []);

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-lottie-column">
          <div className="auth-logo">
            <a 
              href="https://smartcityexposantiagodelestero.com/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <ProxyImage 
                src="https://smartcityexposantiagodelestero.com/wp-content/uploads/2025/03/Logo-SCESDE26-Negro-e1751508867641-1536x213.png" 
                alt="Smart City Expo Santiago del Estero" 
              />
            </a>
          </div>
          <LottieAnimation />
          <div className="auth-partners-image">
            <ProxyImage 
              src="https://smartcityexposantiagodelestero.com/wp-content/uploads/2026/01/Instituciones-Colaboradoras-Web-scaled-e1767776957958.png" 
              alt="Instituciones Colaboradoras" 
            />
          </div>
        </div>
        <div className="auth-form-column">
          <div className="auth-card">
            <div className="auth-logo-mobile">
              <a 
                href="https://smartcityexposantiagodelestero.com/" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <ProxyImage 
                  src="https://smartcityexposantiagodelestero.com/wp-content/uploads/2025/03/Logo-SCESDE26-Negro-e1751508867641-1536x213.png" 
                  alt="Smart City Expo Santiago del Estero" 
                />
              </a>
            </div>
        <h2 className="auth-title">Verificación de Email</h2>

        {status === 'checking' && (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <p style={{ fontFamily: "'Montserrat', sans-serif", color: '#64748b' }}>{message}</p>
          </div>
        )}

        {status === 'success' && (
          <div className="auth-message success">
            {message}
            <div style={{ marginTop: '20px' }}>
              <a href="/perfil" style={{ 
                color: '#CE2B15', 
                textDecoration: 'underline',
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 600
              }}>
                Ir al inicio de sesión
              </a>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className="auth-message error">
            {message}
            <div style={{ marginTop: '20px' }}>
              <a href="/perfil" style={{ 
                color: '#CE2B15', 
                textDecoration: 'underline',
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 600
              }}>
                Volver al inicio
              </a>
            </div>
          </div>
        )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
